import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { QueryKeys } from '../QueryKeys';
import { getRanges, IRange } from '../../api/getRanges';

export const useRanges = (options?: UseQueryOptions<IRange[]>): UseQueryResult<IRange[]> => {
  const { showSnackbar } = useSnackbar();

  return useQuery<IRange[]>({
    queryKey: [QueryKeys.ranges],
    queryFn: async () => {
      return await getRanges();
    },
    onError: () =>
      showSnackbar({ status: SnackbarStatus.ERROR, message: 'Something went wrong whilst fetching product ranges' }),
    ...options,
  });
};
